export default __webpack_public_path__ + "static/media/logout-icon.a59fc8ae.svg";